export const animalPatterns: { [key: string]: string[] } = {
    cat: [
        " _._     _,-'\"\"`-._",
        "(,-.`._,'(       |\\`-/|",
        "    `-.-' \\ )-`( , o o)",
        "          `-    \\`_`\"'-"
    ],
    dog: [
        "  __      _",
        "o'')}____//",
        " `_/      )",
        " (_(_/-(_/"
    ],
    elephant: [
        "    _     _",
        "   /=\\\"\\\"/=\\",
        "  (=(0_0 |=)__",
        "   \\_\\ _/_/   )",
        "     /_/   _  /\\",
        "    |/ |\\ || |",
        "       ~ ~  ~"
    ],
    fish: [
        "|\\   \\\\\\\\__     o",
        "| \\_/    o \\    o",
        "> _   (( <_  oo  ",
        "| / \\__+___/      ",
        "|/     |/"
    ],
    bat: [
        "  _   ,_,   _",
        " / `'=) (='` \\",
        "/.-.-.\\ /.-.-.\\",
        "`      \"      `"
    ],
    monkey: [
        "     __",
        "w  c(..)o   (",
        " \\__(-)    __)",
        "     /\\   (",
        "    /(_)___)",
        "    w /|",
        "     | \\",
        "     m  m"
    ],
    rabbit: [
        "           ,\\",
        "           \\\\\\,_",
        "            \\` ,\\",
        "       __,.-\" =__)",
        "    .\\\"        )",
        " ,_/   ,     \\/\\_",
        "  \\_|    )_-\\ \\_-`",
        "     `-----` `--`"
    ],
    scorpion: [
        " ___     ___",
        "( _<     >_ )",
        "//         \\\\",
        "\\\\___..___//",
        " `-(   )-'",
        "   _|__|_",
        "  /_|__|_\\",
        "  /_|__|_\\",
        "  /_\\__/_\\",
        "   \\ || /   _)",
        "     ||    ( )",
        "      \\\\___//",
        "       `---'"
    ],
    bird: [
        "   \\",
        "    \\\\",
        "     (o>",
        " \\_//)",
        "  \\_/_)"
    ],
    cow: [
        "         (__)",
        "         (oo)",
        "  /-------\\/",
        " / |     ||",
        "*  ||----||",
        "   ^^    ^^"
    ],
    horse: [
        "     >>\\.",
        "    /_  )`.",
        "   /  _)`^)`.   _.---. _",
        "  (_,' \\  `^-)\"\"      `.\\",
        "        |               | \\",
        "         \\              / |",
        "        / \\  /.___.'\\  (\\ (_",
        "       < ,\"||     \\ |`. \\`-`",
        "        \\\\  \\\\     ||  \\)",
        "         `\"\"`\"     `\"\"`"
    ],
    frog: [
        "       @..@",
        "      (----)",
        "     ( >__< )",
        "     ^^ ~~ ^^"
    ],
    penguin: [
        "   .--.",
        "  |o_o |",
        "  |:_/ |",
        " //   \\ \\",
        "(|     | )",
        "/'\\_   _/`\\",
        "\\___)=(___/"
    ],
    duck: [
        "   __",
        " __(o )>",
        "\\ <_. )",
        " `---'"
    ]
};
